import { render, staticRenderFns } from "./PxForm.vue?vue&type=template&id=36902460&lang=pug&"
import script from "./PxForm.vue?vue&type=script&lang=js&"
export * from "./PxForm.vue?vue&type=script&lang=js&"
import style0 from "./PxForm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports